<template>
  <tr class="table-row">
    <td
      class="table-cell"
      v-for="(header, j) in headers"
      :key="j"
      :class="alignment(header)"
    >
      {{ showData(item, header) }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    headers: Array,
    item: Object,
  },
  methods: {
    showData(item, headerItem) {
      const { value } = headerItem;
      return value in item ? item[value] : "";
    },
    alignment(headerItem = {}) {
      const align = headerItem.align || "";
      switch (align) {
        case "left":
          return "align-left";
        case "right":
          return "align-right";
        default:
          return "align-center";
      }
    },
  },
};
</script>

<style scoped>
.align-center {
  text-align: center;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
</style>